import toLink from '@/helpers/toLink';

export const MAX_FILE_NAME_TITLE_LENGTH = 60;

/**
 * Basligi dosya adinda kullanilabilecek uzunluga kisaltir.
 * Sinira kadar olan son kelime sinirindan keser, kelime siniri yoksa dogrudan sinirdan keser.
 *
 * @param {string} title Icerik basligi
 * @param {number} maxLength Basligin dosya adinda kullanilabilecek maksimum uzunlugu
 * @returns {string} Kisaltilmis baslik
 */
export const truncateTitleForFileName = (title, maxLength = MAX_FILE_NAME_TITLE_LENGTH) => {
  const normalizedTitle = String(title || '').trim();

  if (normalizedTitle.length <= maxLength) {
    return normalizedTitle;
  }

  const cutTitle = normalizedTitle.slice(0, maxLength);
  const lastSpaceIndex = cutTitle.lastIndexOf(' ');

  return (lastSpaceIndex > 0 ? cutTitle.slice(0, lastSpaceIndex) : cutTitle).trim();
};

/**
 * Icerik basligi ve verilen ekten (ornegin adim numarasi) dosya adi uretir.
 * Baslik uzunsa MAX_FILE_NAME_TITLE_LENGTH sinirindan kesilir.
 *
 * @param {object} params
 * @param {string} params.title Icerik basligi
 * @param {string|number} [params.suffix] Basliktan sonra eklenecek ek, ornegin 'adim-2-1'
 * @param {string} [params.extension] Nokta ile baslayan dosya uzantisi, ornegin '.jpg'
 * @param {string} [params.locale] Slug uretiminde kullanilacak dil
 * @param {number} [params.maxTitleLength] Baslik icin maksimum uzunluk
 * @returns {string} Uretilen dosya adi, baslik bos ise bos metin
 */
export const buildContentFileName = ({
  title, suffix = '', extension = '', locale, maxTitleLength = MAX_FILE_NAME_TITLE_LENGTH,
}) => {
  const titleSlug = toLink(truncateTitleForFileName(title, maxTitleLength), locale);
  const suffixSlug = toLink(String(suffix ?? ''), locale);
  const nameParts = [titleSlug, suffixSlug].filter(Boolean);

  if (!nameParts.length) {
    return '';
  }

  return `${nameParts.join('-')}${extension}`;
};

export default buildContentFileName;
